module.exports = __webpack_public_path__ + "img/honor-3.f5842048.png";